import { SVGComponentProps } from "./utils/Types"

const HelpIcon = ({ width = 30, height = 30, className }: SVGComponentProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`text-current ${className}`}>
            <circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>

    )
}

export default HelpIcon
